import { render, staticRenderFns } from "./StatisticsMarksByFacultyYear.vue?vue&type=template&id=1f6e7da3"
import script from "./StatisticsMarksByFacultyYear.vue?vue&type=script&lang=js"
export * from "./StatisticsMarksByFacultyYear.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports